module.exports = __webpack_public_path__ + "img/qr_westudy.4cf47669.png";